const BOOKING_COM_SOURCE = "Booking.com";

const isBookingComChannel = value =>
  typeof value === "string" && /booking/i.test(value);

export const getReservationSource = (booking, thread) => {
  const reservationSource = thread?.reservation?.source;
  if (reservationSource) {
    return reservationSource;
  }

  const channelName = booking?.booking_channel?.name || booking?.channel;
  if (isBookingComChannel(channelName)) {
    return BOOKING_COM_SOURCE;
  }

  return undefined;
};
